import { GetServerSideProps, GetServerSidePropsContext, NextPage } from "next";
import React, { useCallback, useEffect, useRef, useState } from "react";
import nookies from "nookies";
import moment from "moment";
import { postRefreshToken } from "../apis/auth";

import { getIdentityProviderEnable } from "../apis/identityProvider";

import dynamic from "next/dynamic";
import DynamicLoading from "../component/default/dynamicLoading";
import { useBoolean } from "../hooks/useBoolean";
import useMain from "../hooks/useMain";
import { wallet_provider_key } from "../config";

const DynamicSignIn = dynamic(
  () => import("../component/account/dynamicSignIn"),
  { ssr: false, loading: () => <DynamicLoading /> }
);

const Signin: NextPage<{ idp?: any[]; error?: any; config?: any }> = ({
  error,
}) => {
  error && console.log(error);

  const { config } = useMain();

  const initFirst = useRef(true);

  const loading = useBoolean(true);

  const [data, setData] = useState<{ idp: any[] }>({
    idp: [],
  });

  const getConfig = useCallback(async () => {
    if (!config?.id) return;

    loading.onTrue();
    try {
      const idp = await getIdentityProviderEnable();

      setData({
        idp: idp?.identityProvider ? idp?.identityProvider : [],
      });
      loading.onFalse();
    } catch (error) {
      loading.onFalse();
    }
  }, [config]);

  useEffect(() => {
    if (initFirst.current) {
      initFirst.current = false;
      getConfig();
    }
    return () => {};
  }, []);

  return loading.value ? (
    <DynamicLoading />
  ) : (
    <DynamicSignIn idp={data.idp} config={config} />
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const urlOrigin =
    process.env.NEXT_PUBLIC_STATE === "development"
      ? undefined
      : process.env.NEXT_PUBLIC_SERVERSIDE_HOST;

  const allCookies = nookies.get(context);
  const token = allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];
  const refresh =
    allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any];

  if (token) {
    return {
      redirect: {
        destination: "/dashboard",
        permanent: false,
      },
    };
  } else if (refresh) {
    const rsRefreshToken: any = await postRefreshToken(refresh, urlOrigin);
    if (rsRefreshToken.code === 200) {
      nookies.set(
        context,
        process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
        rsRefreshToken.result.refreshToken,
        {
          path: "/",
          expires: moment().add(7, "days").toDate(),
          sameSite: "strict",
        }
      );
      nookies.set(
        context,
        process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
        rsRefreshToken.result.accessToken,
        {
          path: "/",
          expires: moment().add(7, "days").toDate(),
          sameSite: "strict",
        }
      );
      return {
        redirect: {
          destination: "/dashboard",
          permanent: false,
        },
      };
    } else {
      nookies.destroy(
        context,
        process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
        {
          path: "/",
        }
      );
      nookies.destroy(context, wallet_provider_key, {
        path: "/",
      });
      return {
        props: {},
      };
    }
  } else {
    return {
      props: {},
    };
  }
};

export default Signin;
